module.exports = __webpack_public_path__ + "img/ben_normal.1585f641.png";